module.exports = __webpack_public_path__ + "img/f0c099ed14898c7a47980bd6bc1e82c7.png";